import React, { memo } from "react";
import styles from "./BillsHeader.module.scss";
import { BackIcon, MobileMenu } from "../../../assets/icons";
import Button from "../../../common/components/xepp/button/Button";
import { useConfigLayout } from "../../../hooks/useConfigLayout";

type Props = {
	onMobileMenuClick: () => void;
};

const BillsHeader: React.FC<Props> = memo((props: Props) => {
	const { onMobileMenuClick } = props;
	const { 
		selectedCountry, 
		selectedUtility,
		isExportButtonVisible,
		isBreadCrumbVisible,
		handleExport,
		handleGoBack
	  } = useConfigLayout();

	return (
		<div>
			<div className={`${styles.container}`}>
				<div className={styles.rightSection}>
					<Button onClick={handleGoBack} leftIcon={<BackIcon style={{ marginRight: 5 }} />} variant="outline" type="button" text="Go Back" />
					{isBreadCrumbVisible && (
						<div className={styles.breadcrumb}>
							<div className={styles.breadcrumbItem}>Countries</div>
							{selectedCountry && (
								<>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>/</div>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>{selectedCountry.name}</div>
								</>
							)}
							{selectedUtility && (
								<>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>/</div>
									<div className={`${styles.breadcrumbItem} ${styles.breadcrumbFade}`}>{selectedUtility.name}</div>
								</>
							)}
						</div>
					)}
				</div>
				{isExportButtonVisible && <Button variant="outline" text="Export" onClick={handleExport} />}
			</div>
			<div className={styles.mobileContainer}>
				<MobileMenu className={styles.mobileMenu} onClick={onMobileMenuClick} />
			</div>
		</div>
	);
});

export default BillsHeader;
